<template>
  <v-app id="app">
    <div class="backdrop" aria-hidden="true">
      <div class="backdrop-grid"></div>
      <div class="backdrop-glow"></div>
    </div>

    <Navbar />

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from "@/components/navBar/NavBar.vue";

export default {
  name: "App",

  components: {
    Navbar,
  },
};
</script>

<style src="./style.scss" lang="scss" />

<style lang="scss">
/* Fundo global: malha técnica + brilho quente muito sutil */
.backdrop {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.backdrop-grid {
  position: absolute;
  inset: -1px;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.028) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(255, 255, 255, 0.028) 1px, transparent 1px);
  background-size: 72px 72px;
  mask-image: radial-gradient(
    ellipse 80% 60% at 50% 0%,
    #000 35%,
    transparent 100%
  );
  -webkit-mask-image: radial-gradient(
    ellipse 80% 60% at 50% 0%,
    #000 35%,
    transparent 100%
  );
}

.backdrop-glow {
  position: absolute;
  top: -22rem;
  left: 50%;
  width: 60rem;
  height: 40rem;
  transform: translateX(-50%);
  background: radial-gradient(
    ellipse at center,
    rgba(255, 176, 32, 0.09),
    transparent 65%
  );
  filter: blur(20px);
}

/* conteúdo sempre acima do fundo */
#app .v-main {
  position: relative;
  z-index: 1;
}
</style>
